import { BusinessSeatsType } from '@api';
import { DotNotationPaths } from '@common';
import { VenueDetailsOverviewEndKey } from 'src/i18next';

export type VenueBusinessSeatsTableRowType = {
  label: VenueDetailsOverviewEndKey<'VENUE_BUSINESS_SEATS.ROWS'>;
  accessor: DotNotationPaths<BusinessSeatsType>;
};

export const venueBusinessSeatsRows: VenueBusinessSeatsTableRowType[] = [
  {
    label: 'MAX_SEATS',
    accessor: 'maxSeats',
  },
  {
    label: 'UPLIFT',
    accessor: 'uplift',
  },
  {
    label: 'SHARE',
    accessor: 'share',
  },
  {
    label: 'NOTES',
    accessor: 'notes',
  },
];

